import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  MessageCircle,
  Linkedin,
  Instagram,
  Facebook,
  Youtube,
  Globe,
  ArrowUpRight,
  type LucideIcon,
} from "lucide-react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  Container,
  Section,
  SectionHeading,
  Card,
  Reveal,
} from "../Components/UI";

const contacts: { Icon: LucideIcon; label: string; value: string; href: string }[] = [
  {
    Icon: Mail,
    label: "Email",
    value: "devyansh@devananta.com",
    href: "mailto:devyansh@devananta.com",
  },
  { Icon: Phone, label: "Phone", value: "+91 82101 52465", href: "tel:+918210152465" },
  { Icon: MessageCircle, label: "WhatsApp", value: "Message me", href: "https://wa.link/srz7dg" },
  { Icon: MapPin, label: "Location", value: "Bengaluru, India", href: "#" },
];

const socials: { Icon: LucideIcon; label: string; href: string }[] = [
  { Icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/devyansh-agrawal/" },
  { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/devyansh_agrawal_/" },
  { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/devyansh.agarwal.75" },
  { Icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@devyanshagrawal8882" },
  { Icon: Globe, label: "DevAnanta", href: "https://devananta.com/" },
];

const ContactPage: React.FC = () => {
  return (
    <main className="bg-ink-950 pt-16 md:pt-20">
      <Navbar />

      <Section>
        <Container>
          <Reveal>
            <SectionHeading
              eyebrow="Connect"
              title="Let's build something meaningful"
              intro="I'm open to deep-tech partnerships, climate-tech collaborations and investor conversations. The fastest way to reach me is below."
            />
          </Reveal>

          <div className="mx-auto mt-14 grid max-w-4xl gap-6 sm:grid-cols-2">
            {contacts.map((c, i) => {
              const external = c.href.startsWith("http");
              const isPlaceholder = c.href === "#";
              const inner = (
                <Card className="flex h-full items-center gap-4 p-6 transition-colors hover:border-brand-500/40">
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand-500/10 text-brand-400">
                    <c.Icon className="h-6 w-6" />
                  </span>
                  <span>
                    <span className="block text-xs uppercase tracking-wide text-zinc-500">
                      {c.label}
                    </span>
                    <span className="mt-0.5 block font-medium text-white">
                      {c.value}
                    </span>
                  </span>
                </Card>
              );
              return (
                <Reveal key={c.label} delay={i * 80}>
                  {isPlaceholder ? (
                    inner
                  ) : (
                    <a
                      href={c.href}
                      {...(external
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                      className="block h-full"
                    >
                      {inner}
                    </a>
                  )}
                </Reveal>
              );
            })}
          </div>

          {/* Socials */}
          <Reveal>
            <div className="mx-auto mt-12 max-w-4xl">
              <p className="text-center text-sm uppercase tracking-[0.18em] text-zinc-500">
                Find me online
              </p>
              <div className="mt-6 flex flex-wrap justify-center gap-3">
                {socials.map(({ Icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="inline-flex items-center gap-2 rounded-full border border-white/10 px-5 py-2.5 text-sm font-medium text-zinc-300 transition-colors hover:border-brand-500/50 hover:text-brand-400"
                  >
                    <Icon className="h-4 w-4" /> {label}
                  </a>
                ))}
              </div>
            </div>
          </Reveal>

          {/* DevAnanta */}
          <Reveal>
            <div className="mx-auto mt-14 max-w-4xl rounded-3xl border border-brand-500/20 bg-gradient-to-br from-brand-600/20 via-ink-900 to-ink-900 px-6 py-12 text-center sm:px-12">
              <h2 className="font-display text-2xl font-bold text-white">
                Curious about the technology?
              </h2>
              <p className="mx-auto mt-3 max-w-md text-zinc-300">
                Explore DevAnanta R&D — India's rare-earth-free energy storage,
                made from waste.
              </p>
              <a
                href="https://devananta.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-brand-500 px-6 py-3 text-sm font-semibold text-ink-950 shadow-glow transition-transform hover:-translate-y-0.5 hover:bg-brand-400"
              >
                Visit devananta.com <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        </Container>
      </Section>

      <Footer />
    </main>
  );
};

export default ContactPage;
